const mediaItems = [
  {
    title: '《星际拓荒者》科幻巨制',
    desc: '震撼视觉特效，带你穿越未知星系，探索人类新家园。4K杜比全景声版本现已上线。',
    tag: '院线同步',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20science%20fiction%20movie%20poster%20style%2C%20futuristic%20spaceship%20in%20deep%20space%20with%20vibrant%20nebula%20colors%2C%20dramatic%20lighting%2C%20epic%20scale%2C%20warm%20orange%20and%20teal%20color%20grade%2C%20cinematic%20composition%2C%20dark%20background%20with%20bright%20stars%2C%20movie%20poster%20aesthetic&width=800&height=500&seq=media-scifi-2026&orientation=landscape',
  },
  {
    title: '《暗夜追踪》悬疑大剧',
    desc: '国产悬疑巅峰之作，12集紧凑剧情环环相扣，结局反转让人拍案叫绝。',
    tag: '全集完结',
    img: 'https://readdy.ai/api/search-image?query=Dark%20mystery%20thriller%20cinematic%20scene%2C%20rainy%20city%20street%20at%20night%20with%20neon%20reflections%2C%20noir%20atmosphere%2C%20detective%20silhouette%20in%20trench%20coat%2C%20dramatic%20shadows%2C%20warm%20amber%20streetlights%20contrasting%20cool%20blue%20night%2C%20cinematic%20photography%20style&width=800&height=500&seq=media-mystery-2026&orientation=landscape',
  },
  {
    title: '《笑声制造机》爆款综艺',
    desc: '全明星阵容欢乐集结，新一季玩法升级，首期播放量破亿，承包你的快乐时光。',
    tag: '热播综艺',
    img: 'https://readdy.ai/api/search-image?query=Bright%20and%20energetic%20variety%20show%20stage%20scene%2C%20colorful%20studio%20lighting%20with%20warm%20spotlights%2C%20entertainment%20show%20atmosphere%2C%20cheerful%20and%20lively%20vibe%2C%20professional%20studio%20setup%20with%20vibrant%20neon%20accents%2C%20dynamic%20composition&width=800&height=500&seq=media-variety-2026&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 font-heading mb-3">
            精彩推荐
          </h2>
          <p className="text-foreground-600 max-w-lg mx-auto">
            本周必看精选，高清画质畅享观影体验
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className="group bg-background-50 border border-background-200 rounded-xl overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative overflow-hidden aspect-video">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  width="400"
                  height="250"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-full">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-background-50/90 text-primary-600 group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-2xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-semibold text-foreground-900 mb-2 font-heading">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}